export default __webpack_public_path__ + "static/kokall-mobiel-zomer-1-9eef55fddb0fd11b3654ce7039e17ae8.png";